module.exports = __webpack_public_path__ + "img/476.087b49b2.jpg";